import { VFC } from 'react';

export class HttpError extends Error {
  public statusCode;

  public constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
  }
}

export const Error403: VFC = () => {
  throw new HttpError('Forbidden', 403);
};

export const Error404: VFC = () => {
  throw new HttpError('Not found', 404);
};

export const Error500: VFC = () => {
  throw new HttpError('Server error', 500);
};
